import React, { useState, useContext, useEffect } from 'react';
import { FeedArea } from '@go-shared/types/feedTemplate';
import { hotspotTarget, collectTarget } from '@go-client/lib/feedEditor';
import { BareContentTemplateLegacy } from '@go-shared/types/contentTemplate';
import { DropTarget } from 'react-dnd';
import { CONTENT_DND_TYPE } from '@go-client/components/DraggableContentItem';
import { FeedEditorCtx } from '@go-client/context/FeedEdtitorContext';
import { InlineIcon } from '@spark-labs/avocado-ui';

interface FeedEditorTextProps {
  parent: FeedArea;
  onDrop?: (contentTemplate: BareContentTemplateLegacy) => void;
  connectDropTarget?: any;
  isOver?: boolean;
  onContentChange: (area: FeedArea, contentTemplate: BareContentTemplateLegacy) => void;
  onElementChanged: (area: FeedArea) => void;
}

const FeedEditorText: React.FC<FeedEditorTextProps> = ({
  parent,
  connectDropTarget,
  onElementChanged,
}) => {
  const [text, setText] = useState(parent.params!.text!);
  const { setEditorElement, lastStyles, content, currentArea, editMode } =
    useContext(FeedEditorCtx);
  const [updatedStyles, setUpdatedStyles] = useState({});
  useEffect(() => {
    if (content && isSameArea) {
      setText(content);
      onElementChanged({ ...parent, params: { text: content } });
    }
  }, [content]);

  useEffect(() => {
    if (isSameArea) {
      setUpdatedStyles(lastStyles);
      onElementChanged({ ...parent, style: lastStyles });
    }
  }, [lastStyles]);

  const isSameArea = currentArea && currentArea._id === parent._id;
  const textStyles = { ...parent.style, ...updatedStyles, width: '100%', lineHeight: 1 };

  const renderComponent = () => {
    return (
      <div className={`feed-text block w-full relative cursor-pointer`}>
        <div
          className={parent.className}
          style={textStyles}
          dangerouslySetInnerHTML={{ __html: text }}
        ></div>

        {editMode && !parent.isLocked && (
          <button
            className="absolute"
            style={{ right: 10, top: 5 }}
            onClick={() => setEditorElement({ ...parent, style: updatedStyles, params: { text } })}
          >
            <InlineIcon name="edit" />
          </button>
        )}
      </div>
    );
  };

  return connectDropTarget(renderComponent());
};

export default DropTarget<FeedEditorTextProps>(
  CONTENT_DND_TYPE,
  hotspotTarget,
  collectTarget
)(FeedEditorText);
